// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"cc3b6a9e","457":"8c7f8379","488":"7a876c9d","551":"f7125d0a","627":"e289da1b","637":"f4b76548","653":"dc467ce0","738":"a14ce53f","760":"bcd9df01","851":"40370a30","923":"dfa14e0e"}[chunkId] + ".chunk.js";
};